import {DocumentsDirectionTypes} from "../documents/models/enums";
import i18n from "../i18n/i18n";

export default class DocumentsDirectionTypeDropdownItems {
    public static getDocumentsDirectionTypeDropdownItems () {
        return [
            {
                id: DocumentsDirectionTypes.ARRIVAL,
                name: i18n.t("directionType.ARRIVAL")
            },
            {
                id: DocumentsDirectionTypes.DEPARTURE,
                name: i18n.t("directionType.DEPARTURE")
            }
        ];
    }
}